import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-insights-panel',
  templateUrl: './insights-panel.component.html',
  styleUrls: ['./insights-panel.component.scss']
})
export class InsightsPanelComponent implements OnInit {

  insightsUrl!: SafeResourceUrl;

  constructor(private translate: TranslateService, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.updateInsightsUrl();
    
    this.translate.onLangChange.subscribe(() => {
      this.updateInsightsUrl();
    });
  }

  private updateInsightsUrl(): void {
    const rawUrl = this.translate.instant('Home.insights');
    this.insightsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
  }
}